import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import AppModel from '../DataModel/AppModel';
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import {
  DatePicker,
  MenuItem,
  SelectField,
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow, TableRowColumn
} from "material-ui";
import PageLoading from "../components/PageLoading";
import {observer} from 'mobx-react';
import moment from "moment";
import AppModelUtils from "../DataModel/AppModelUtils";

let logJsonStyle = {
  display: "block",
  overflow: "visible",
  padding: "15px 0"
};

let pageStyle = {
  margin: "1em",
};

let headerStyle = {
  fontFamily: "Roboto, sans-serif",
  fontSize: "20px",
  fontWeight: "400",
  height: "48px",
  lineHeight: "48px"
};

let formContentStyle = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between"
};

let formContentColumnStyle = {
  flex: "0 0 48%"
};

let tableCardStyle = {
  marginTop: '1rem'
};

let SelectFieldOverflowStyleFix = {
  overflow: "hidden"
};

export default @observer

class AuditLogPage extends Component {


  setPickedDate(request, field) {
    return (event, value) => {
      request[field] = value;
      this.postAuditLogRequest()
    }
  }

  setAuditLogField(request, field) {
    return (event, index, value) => {
      
      if(value == 'ALL_USERS' || value == 'ALL_ENTITIES') value = '';
      request[field] = value;
      this.postAuditLogRequest()
    }
  }

  userChoices() {
    let userlist = [];
    for(const a of AppModel.auditLog){      
      if(!userlist.some(user => user.id_user == a.id_user)){
        userlist.push(a)
      }
    }
    
    return userlist.map(user =>
      <MenuItem key={user.id_user}
                value={user.id_user}
                primaryText={user.name}/>
    )
  }

  availableEntities() {
    return AppModel.auditLogSearchForm.request.allEntities.map(e =>
      <MenuItem key={e}
                value={e}
                primaryText={this.getEntityName(e)}/>
    )
  }

  customerChoices() {        
    return AppModel.customerListIncludingOwnCompany.map((c, index) =>
      <MenuItem key={c.id}
                value={c.id}
                primaryText={c.name + " (" + c.id + ")"}/>
    )
  }

  formatDateForDisplay(date) {
    return moment(date).tz(AppModel.time_zone).locale(AppModel.locale).format("ll");
  }

  formatDateTimeForDisplay(date) {
    return moment(date).tz(AppModel.time_zone).locale(AppModel.locale).format("LLL");
  }

  getEntityName(id, action){
    if(action){
      return uiMsg(`AL_ENTITY_${id}_${action}`, `${id}_${action}`)
    }
    return uiMsg(`AL_ENTITY_${id}`, id)
  }

  resetSearchForm() {
    AppModel.auditLogSearchForm.reset();
    this.postAuditLogRequest();
  }

  postAuditLogRequest() {
    AppModelUtils.fetch_audit_log();
  }


  render() {

    var request = AppModel.auditLogSearchForm.request;
    return (
      <PageLoading loading={AppModel.fetchingUserList || AppModel.customerListLoading}>

        <div style={pageStyle}>

          <h2 style={headerStyle}>{uiMsg('PT_AUDIT_LOG', "Audit log")}</h2>

          <Card style={{maxWidth: "60rem"}}>
            <CardHeader style={{paddingBottom: "0"}}
                        title={uiMsg('AL_FILTER', "Filter")}/>
            <CardText style={{padding: "0 30px 30px 30px"}}>
              <div style={formContentStyle}>
                <div style={formContentColumnStyle}>
                  <DatePicker
                    floatingLabelText={uiMsg('AL_FROM', "From")}
                    hintText={uiMsg('AL_FROM_HINT', "From date")}
                    value={request.date_from}
                    fullWidth={true}
                    formatDate={this.formatDateForDisplay}
                    onChange={this.setPickedDate(request, 'date_from')}
                  />
                </div>
                <div style={formContentColumnStyle}>
                  <DatePicker
                    floatingLabelText={uiMsg('AL_TO', "To")}
                    hintText={uiMsg('AL_TO_HINT', "To date")}
                    value={request.date_to ? request.date_to : new Date()}
                    fullWidth={true}
                    formatDate={this.formatDateForDisplay}
                    onChange={this.setPickedDate(request, 'date_to')}
                  />
                </div>
              </div>
              <div style={formContentStyle}>
                <div style={formContentColumnStyle}>
                  <SelectField
                    disabled={false}
                    floatingLabelText={uiMsg('AL_SELECT_CUSTOMER', "Select customer")}
                    hintText={uiMsg('AL_SELECT_CUSTOMER_HINT', "Select customer")}
                    value={request.id_customer}
                    fullWidth={true}
                    style={SelectFieldOverflowStyleFix}
                    onChange={this.setAuditLogField(request, 'id_customer')}>
                    {this.customerChoices()}
                  </SelectField>
                </div>
                <div style={formContentColumnStyle}>
                  <SelectField
                    disabled={false}
                    floatingLabelText={uiMsg('AL_SELECT_USER', "Select user")}
                    hintText={uiMsg('AL_SELECT_USER_HINT', "Select user")}
                    value={request.id_user ? request.id_user : 'ALL_USERS'}
                    fullWidth={true}
                    style={SelectFieldOverflowStyleFix}
                    onChange={this.setAuditLogField(request, 'id_user')}>
                      <MenuItem
                        key={'ALL_USERS'}
                        value={'ALL_USERS'}
                        primaryText={uiMsg('ALL', 'All')}
                        selected/>
                    {AppModel.fetchingUserList ? 'Loading...' : this.userChoices()}
                  </SelectField>
                </div>
              </div>
              <div style={formContentStyle}>
                <div style={formContentColumnStyle}>
                  <SelectField
                    disabled={false}
                    floatingLabelText={uiMsg('AL_SELECT_ENTITY', "Select entity")}
                    hintText={uiMsg('AL_SELECT_ENTITY_HINT', "Select entity")}
                    value={request.entity ? request.entity : 'ALL_ENTITIES'}
                    fullWidth={true}
                    style={SelectFieldOverflowStyleFix}
                    onChange={this.setAuditLogField(request, 'entity')}>
                    <MenuItem
                        key={'ALL_ENTITES'}
                        value={'ALL_ENTITIES'}
                        primaryText={uiMsg('ALL', 'All')}/>
                    {this.availableEntities()}
                  </SelectField>
                </div>
              </div>
              <div style={formContentColumnStyle}>
              </div>


            </CardText>
            <CardActions>
              <FlatButton
                label={uiMsg('AL_RESET_FILTER', "Reset")}
                primary={true}
                onTouchTap={this.resetSearchForm.bind(this)}/>
            </CardActions>
          </Card>

          <PageLoading
            loading={AppModel.fetchingAuditLog}>
            <Card style={tableCardStyle}>

              <Table selectable={false}>
                <TableHeader displaySelectAll={false}
                             adjustForCheckbox={false}>
                  <TableRow>
                    <TableHeaderColumn>{uiMsg('AL_TABLE_HEADER_TIME', "Time")}</TableHeaderColumn>
                    <TableHeaderColumn>{uiMsg('AL_TABLE_HEADER_ENTITY', "Entity")}</TableHeaderColumn>
                    <TableHeaderColumn>{uiMsg('AL_TABLE_HEADER_CUSTOMER', "Customer")}</TableHeaderColumn>
                    <TableHeaderColumn>{uiMsg('AL_TABLE_HEADER_USER', "User")}</TableHeaderColumn>
                    <TableHeaderColumn style={{width: '30%'}}>{uiMsg('AL_TABLE_HEADER_DATA', "Data")}</TableHeaderColumn>
                  </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false}>
                  {AppModel.auditLog.map((a, index) => (
                    <TableRow key={index}>
                      <TableRowColumn>{this.formatDateTimeForDisplay(a.action_tstamp)}</TableRowColumn>
                      <TableRowColumn>{this.getEntityName(a.table_name, a.action)}</TableRowColumn>
                      <TableRowColumn>{a.customer_name}</TableRowColumn>
                      <TableRowColumn>{a.id_user}{a.client_ip ? `/${a.client_ip}` : null}</TableRowColumn>
                      <TableRowColumn  style={{width: '30%'}}>
                        <pre style={logJsonStyle}>
                          {JSON.stringify(a.row_data, undefined, 2)}
                        </pre>
                      </TableRowColumn>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>

            </Card>
          </PageLoading>


        </div>
      </PageLoading>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./src/pages/AuditLogPage.jsx
 **/